import { tieneRol } from './auth/roles'
import { LangProvider, useLang } from './i18n/LangProvider'
import { t } from './catalogo/i18n'
import { Routes, Route, Navigate } from 'react-router-dom'
import './App.css'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { RoleGuard } from './auth/RoleGuard'
import { useAuth } from './auth/useAuth'
import { AdminLayout } from './admin/AdminLayout'
import { UsersPage } from './admin/users/UsersPage'
import { TemporadasPage } from './admin/temporadas/TemporadasPage'
import { EquiposPage } from './admin/equipos/EquiposPage'
import { HistoricoPage } from './admin/historico/HistoricoPage'
import { AppShell } from './catalogo/AppShell'
import { ScopeGuard } from './catalogo/ScopeGuard'
import { EquipoDetailPage } from './catalogo/EquipoDetailPage'
import { PanelPage } from './panel/PanelPage'
import { ManualPage } from './ayuda/ManualPage'
import { UsoPage } from './admin/uso/UsoPage'
import { ReporteErrores } from './uso/ReporteErrores'

function Home() {
  const { user, noAccount, logout } = useAuth()
  const lang = useLang()

  if (noAccount) {
    return (
      <div>
        <h3>{t('sinAcceso', lang)}</h3>
        <p>{t('sinCuentaMensaje', lang)}</p>
        <button onClick={() => logout()}>{t('salir', lang)}</button>
      </div>
    )
  }
  if (!user) return <div>{t('cargando', lang)}</div>
  // admin exclusivo (sin ningún otro rol) va directo al backoffice; con algún rol deportivo además,
  // aterriza en la vista de equipos como cualquier otro rol, con un enlace al backoffice desde ahí.
  if (tieneRol(user, 'admin') && !tieneRol(user, 'director', 'coordinador', 'entrenador')) {
    return <Navigate to="/admin" replace />
  }
  return <AppShell />
}

function App() {
  return (
    <ProtectedRoute>
      <LangProvider>
      <ReporteErrores />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/equipos/:id"
          element={
            <ScopeGuard>
              <EquipoDetailPage />
            </ScopeGuard>
          }
        />
        {/* Petición del club (2026-10-31): manual de usuario, para cualquier usuario con sesión. */}
        <Route path="/ayuda" element={<ManualPage />} />
        <Route
          path="/panel"
          element={
            <RoleGuard roles={['admin', 'director', 'coordinador']}>
              <PanelPage />
            </RoleGuard>
          }
        />
        <Route
          path="/admin"
          element={
            <RoleGuard roles={['admin', 'director']}>
              <AdminLayout />
            </RoleGuard>
          }
        >
          <Route
            index
            element={
              <RoleGuard roles={['admin']}>
                <UsersPage />
              </RoleGuard>
            }
          />
          <Route
            path="usuarios"
            element={
              <RoleGuard roles={['admin']}>
                <UsersPage />
              </RoleGuard>
            }
          />
          <Route
            path="temporadas"
            element={
              <RoleGuard roles={['admin']}>
                <TemporadasPage />
              </RoleGuard>
            }
          />
          <Route
            path="equipos"
            element={
              <RoleGuard roles={['admin']}>
                <EquiposPage />
              </RoleGuard>
            }
          />
          <Route path="historico" element={<HistoricoPage />} />
          {/* Petición del club (2026-10-31): estadísticas de uso, rendimiento y fallos. */}
          <Route
            path="uso"
            element={
              <RoleGuard roles={['admin']}>
                <UsoPage />
              </RoleGuard>
            }
          />
        </Route>
      </Routes>
      </LangProvider>
    </ProtectedRoute>
  )
}

export default App